import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import Footer from "@/components/Footer";
import { ShieldAlert, Mail, User } from "lucide-react";

export default function Legal() {
  const { doc } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => { setData(null); setErr(false); api.get(`/legal/${doc}`).then(({ data }) => setData(data)).catch(() => setErr(true)); }, [doc]);

  if (err) return <div className="min-h-[60vh] flex items-center justify-center text-charcoal/50">Document not found.</div>;
  if (!data) return <div className="min-h-[60vh] flex items-center justify-center"><div className="w-10 h-10 rounded-full border-4 border-terracotta border-t-transparent animate-spin" /></div>;

  return (
    <div className="bg-sand">
      <div className="max-w-3xl mx-auto px-5 md:px-8 py-14">
        <div className="bg-sun/15 border border-sun rounded-xl p-4 flex items-start gap-3 mb-8">
          <ShieldAlert className="w-5 h-5 text-charcoal mt-0.5 shrink-0" />
          <p className="text-sm text-charcoal/80">These are <strong>drafts</strong> for demonstration. All legal documents and statutory timelines must be verified with a licensed Indian lawyer before use.</p>
        </div>
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-charcoal/40">{data.updated}</p>
        <h1 className="font-display text-4xl md:text-5xl font-black text-charcoal mt-2">{data.title}</h1>

        {data.officer && (
          <div className="bg-white rounded-2xl border border-border p-6 mt-6">
            <h3 className="font-display text-lg font-bold text-charcoal">Grievance Officer</h3>
            <div className="mt-3 space-y-1.5 text-sm text-charcoal/70">
              <p className="flex items-center gap-2"><User className="w-4 h-4 text-terracotta" /> {data.officer.name} — {data.officer.designation}</p>
              <p className="flex items-center gap-2"><Mail className="w-4 h-4 text-terracotta" /> {data.officer.email}</p>
              <p className="text-xs text-charcoal/50">{data.officer.note}</p>
            </div>
          </div>
        )}

        <div className="mt-8 space-y-7">
          {data.sections.map((s, i) => (
            <div key={i}>
              <h2 className="font-display text-xl font-bold text-charcoal">{s.h}</h2>
              <p className="text-charcoal/75 mt-2 leading-relaxed">{s.p}</p>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
